import React from 'react';
import './index.less';
import addDOMEventListener from 'add-dom-event-listener';
import ReactDOM from 'react-dom';
import { MonthComponent, Handle } from 'libs';
import { Button } from 'antd';

const GLOBAL_WIDTH = 860; // 定宽

class SchduleHeader extends React.Component {
    constructor (props) {
        super(props);
    }

    getList (length) {
        var result = new Array(length).fill(1).map((item, index) => {
            return index;
        });
        return result;
    }

    // 计算每一个数字的线框宽度
    getListWidth (length, allWidth) {
        var lastWidth = 30;
        // 预留一个特殊宽度
        return Math.floor((allWidth - lastWidth) / (length - 1));
    }

    render () {
        var { width } = this.props;
        var allLength = 25;
        var list = this.getList(allLength);

        var getListWidth = this.getListWidth(allLength, GLOBAL_WIDTH);

        return (
            <div className="schedule_header">
                <label className='mark-area'>{/*占位*/}</label>
                {
                    list.map((item, index) => {
                        if (index === allLength - 1) {
                            return (
                                <label key={index}
                                    className='header-item'
                                    style={{ width: '20px' }}>{item}</label>
                            );
                        } else {
                            return (
                                <label key={index}
                                    className='header-item'
                                    style={{ width: getListWidth }}>{item}</label>
                            );
                        }
                    })
                }
            </div>
        );
    }
}
// 当前的行显示
class RowSchdule extends React.Component {
    constructor (props) {
        super(props);
    }

    onCopyClick () {
        if (this.props.onCopy) {
            this.props.onCopy();
        }
    }

    render () {
        var { labeltext, $t } = this.props;
        return (
            <div className='RowSchdule fn-clear'>
                <div className='row-left fn-left'>{labeltext}</div>
                <div className='row-middle fn-left'>{this.props.children}</div>
                <div className='row-right fn-left'>
                    <Button className='copy-btn' onClick={this.onCopyClick.bind(this)} type="link">{$t('com.Copy')}</Button>
                </div>
            </div>
        );
    }
}

class SceneSchdule extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            maxLength: 6, // 暂定默认最多有6个数据
            monthTransMap: [
                'com.January', // 1月
                'com.FebruDay', // 2月
                'com.March', // 3月
                'com.April', // 4月
                'com.May', // 5月
                'com.June', // 6月
                'com.July', // 7月
                'com.August', // 8月
                'com.Sep', // 9月
                'com.October', // 10月
                'com.Novermber', // 11月
                'com.December', // 12月
            ]
        };
    }

    onScheduleChange = (value, level) => {
        var { curModel = 'Day' } = this.props; // 默认白天模式
        var { maxLength } = this.state;
        var { schduleData } = this.props;

        schduleData[level] = value;
        var copyData = value.slice();
        var lastData = copyData.pop(); // 取当前数据的最后一条

        /*
        * schdule组件中，增加了是否拖动的判断，如果不是拖动，会删除无效数据
        * 删除无效数据后，就会引入这个undefined，所以这里要处理掉
        */
        if (lastData === undefined) {
            return;
        }

        var splitLastData = lastData.split(' ');

        // 说明当前这个数据是新增的,所以没有模式
        if (splitLastData[1] === 'undefined') {
            schduleData[level].pop(); // 删除有误数据
            lastData = splitLastData[0] + ' ' + curModel; // 把数据拼接好
            schduleData[level].push(lastData); // 放回数据
        }

        if (this.props.onChange) {
            this.props.onChange([...new Set(schduleData)], level);
        }
    }

    onChangeHandleData = (v, index) => {
        this.handleRef.setContainer(v);
        if (this.props.changeHandleData) {

            this.props.changeHandleData(v, index);
        }
    }

    onCopyTime (level) {
        if (this.props.onCopy) {
            this.props.onCopy(level);
        }
    }

    render () {
        var { schduleData, $t } = this.props;
        var { monthTransMap } = this.state;
        return (
            <div className='_ScheduleComponent_ schedule_wrap' ref={(v) => this.scheduleRef = v}>
                <div>
                    <SchduleHeader />
                </div>
                {
                    schduleData.map((item, index) => {
                        return (
                            <RowSchdule key={index}
                                labeltext={$t(monthTransMap[index])}
                                $t={$t}
                                onCopy={this.onCopyTime.bind(this, index)}>
                                <MonthComponent
                                    label='mmp'
                                    data={item}
                                    min={0}
                                    max={1440 * 60}
                                    width={GLOBAL_WIDTH}
                                    prefixCls='onlyNormal'
                                    onChange={(value) => this.onScheduleChange(value, index)}
                                    changeHandleData={(v) => { this.onChangeHandleData(v, index); }}>
                                </MonthComponent>
                            </RowSchdule>
                        );
                    })
                }
                <Handle prefixCls={'onlyNormal'}
                    min={0}
                    max={1440 * 60}
                    ref={(v) => this.handleRef = v}
                    ScheduleContainer={this.scheduleRef}
                ></Handle>
            </div>
        );
    }
}

export default SceneSchdule;